import React from "react";
import { SnackbarProvider } from "notistack";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Provider } from "react-redux";
import { ToastContainer, Zoom } from 'react-toastify';
import { ReactKeycloakProvider } from "@react-keycloak/web"
import DateFnsUtils from "@date-io/date-fns";
import BR from "date-fns/locale/pt-BR";

import Router from "./Router";
import store from "./Store/storeConfig";
import temaAplicacao from "./Styles/Temas/temaAplicacao";
import "./Styles/SCSS/global.scss";
import 'react-toastify/dist/ReactToastify.css';
import keycloack, { keycloakInitConfiguration } from "./keycloak";
import { setSessaoToken } from "./Utils/token";

export const finalStore = store

export default function App() {   
    return (
        <ReactKeycloakProvider 
        authClient={keycloack} 
        initOptions={
            keycloakInitConfiguration
        }
        onTokens={({token}) => {
            setSessaoToken({
                access_token: token
            })
        }}
        >
            <Provider store={finalStore}>
                <MuiThemeProvider theme={temaAplicacao}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={BR}>
                        <SnackbarProvider>
                            <Router />
                        </SnackbarProvider>
                    </MuiPickersUtilsProvider>
                </MuiThemeProvider>
                <ToastContainer position='bottom-center' hideProgressBar={true} autoClose={4000} transition={Zoom}/>
            </Provider>
        </ReactKeycloakProvider>
    );
}